/**
 * Action tactic types for action post create (labels + descriptions for select UI).
 */
export type ActionTypeValue =
  | "protest"
  | "rally"
  | "strike"
  | "blockade"
  | "boycott"
  | "divest"
  | "blackout"
  | "petition"
  | "contact"
  | "comment"
  | "vote"
  | "register"
  | "buycott"
  | "donate"
  | "fundraise"
  | "volunteer"
  | "canvass"
  | "share"
  | "report"
  | "records-request"
  | "build";

export const ACTION_TYPE_META: Record<ActionTypeValue, { label: string; description: string }> = {
  protest: { label: "Protest", description: "Public demonstration to show support or opposition." },
  rally: { label: "Rally", description: "Public demonstration to show support for an issue." },
  strike: { label: "Strike", description: "Workers/students stop work/classes to apply pressure." },
  blockade: { label: "Blockade", description: "Occupy or block access to disrupt business‑as‑usual." },
  boycott: { label: "Boycott", description: "Stop buying or using to pressure change." },
  divest: { label: "Divest", description: "Pull investments or contracts from a target institution." },
  blackout: { label: "Blackout", description: "Time‑boxed coordinated non‑use or sign‑off to signal protest." },
  petition: { label: "Petition", description: "Collect signatures to request a specific action." },
  contact: { label: "Contact", description: "Call, email, or message decision‑makers directly with a demand." },
  comment: { label: "Comment", description: "Submit official feedback or testimony to a government or board." },
  vote: { label: "Vote", description: "Cast a ballot in an election or referendum." },
  register: { label: "Register", description: "Register or verify voter registration status." },
  buycott: { label: "Buycott", description: "Intentionally buy from preferred alternatives to support them." },
  donate: { label: "Donate", description: "Give money or goods to a cause or campaign." },
  fundraise: { label: "Fundraise", description: "Organize or host efforts to get others to donate." },
  volunteer: { label: "Volunteer", description: "Offer time or skills for a cause or event." },
  canvass: { label: "Canvass", description: "Outreach to many people for persuasion or turnout." },
  share: { label: "Share", description: "Amplify content, hashtags, or links to spread the message." },
  report: { label: "Report", description: "File a complaint or tip with a platform, regulator, or watchdog." },
  "records-request": { label: "Records Request", description: "Request public records or data (e.g., FOIA)." },
  build: { label: "Build", description: "Create or maintain tools, documentation, or community infrastructure." },
};
